import React, {useState} from "react";
import {Foot, Section, LogoFooter, TitleFooter, SubtitleFooter, FormSubmit, InputForm, Logos, ButtonSubmit} from "./styles";
import InfoSection from "./InfoSection";
import InstaLogo from "../../assets/icons/insta.svg";
import FaceLogo from "../../assets/icons/face.svg";
import Arrow from "../../assets/icons/arrow_right.png";
import {Content} from "../../styles/GlobalStyles";
import PrivacyView from "../../views/privacy/PrivacyView";
import TermsView from "../../views/terms/TermsView";

const Footer = () => {
   const [email, setEmail] = useState("");
   function sendEmail(e) {
      e.preventDefault();
      const email = e.target.email.value;
      setEmail(email);
   }
   return (
      <>
         <Foot id="footer">
            <Content className="footerContainer">
               <Section>
                  <div className="mobileFlex">
                     <LogoFooter>
                        <img src={require("../../assets/logo/footer.png")} alt="footer" />
                     </LogoFooter>
                     <TitleFooter>CONÉCTATE CON DOMECQ ACADEMY</TitleFooter>
                  </div>
                  {email ? (
                     <TitleFooter>Correo enviado a {email}</TitleFooter>
                  ) : (
                     <>
                        <FormSubmit onSubmit={sendEmail}>
                           <div>
                              <SubtitleFooter className="form">Suscríbete a nuestro newsletter</SubtitleFooter>
                           </div>
                           <div className="align">
                              <InputForm type="email" placeholder="Correo electrónico" name="email" />
                              <ButtonSubmit>
                                 <img src={Arrow} alt="send" />
                              </ButtonSubmit>
                           </div>
                        </FormSubmit>
                     </>
                  )}
                  <Logos>
                     <a href="https://www.instagram.com/domecq_academy/" target="_blanck">
                        <img src={InstaLogo} alt="ins" />
                     </a>
                     <a href="https://www.facebook.com/DomecqAcademy/" target="_blanck">
                        <img src={FaceLogo} alt="fb" />
                     </a>
                  </Logos>
               </Section>
               <InfoSection />
            </Content>
         </Foot>
         <PrivacyView />
         <TermsView />
      </>
   );
};

export default Footer;
